import { get } from 'lodash'

export function getErrorMessage(error) {
  const url = get(error, 'config.url');
  return [
    error.message,
    url ? ` accessing ${url}` : ''
  ].join('');
}
